import { cn } from "@/lib/utils";

/**
 * Clapping-hands glyph drawn in the same stroke style as the lucide trim icons
 * used across the navigation, so it sits inline with Radius / Trending / Music etc.
 */
const ClapIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={cn("w-5 h-5", className)}
  >
    {/* left hand */}
    <path d="M11 13.5 7.6 10a1.6 1.6 0 0 0-2.3 2.3l3.9 4.2a5.2 5.2 0 0 0 7.5.1l2.2-2.2a1.6 1.6 0 0 0-2.3-2.3l-1.3 1.3" />
    <path d="m14.9 12.6-3.6-3.7a1.6 1.6 0 1 1 2.3-2.3l3.1 3.2" />
    <path d="m12.4 8.3-2.6-2.7a1.6 1.6 0 1 1 2.3-2.3l3.5 3.6" />
    {/* motion sparks */}
    <path d="M4.5 5.6 3.4 4.4M8 3.6V2M2.8 9.4H1.4" />
  </svg>
);

export default ClapIcon;
